import {
    PACKAGE_DRAFT_RESET_DATA
} from './actionTypes';

export const packageDraftResetData = () => {
    return {
        type: PACKAGE_DRAFT_RESET_DATA,
    }
};